import { Extension } from '@tiptap/core'
import Suggestion from '@tiptap/suggestion'
import { Plugin } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'
import { PluginKey } from '@tiptap/pm/state'
const hashtagRe = /(?:^|\s)(?<hashtag>#(\w*[A-Za-z_]+\w*))/g
const hashtagChar = '@'

export const Relation = Extension.create({
  name: 'relation',

  addOptions: {
    HTMLAttributes: {},
    re: hashtagRe,
    char: hashtagChar,
    startOfLine: false,
    allowSpaces: false,
    decorationClass: 'relation',
  },

  addProseMirrorPlugins() {
    const plugins = []

    const findHashtags = (doc) => {
      const result = []
      const hashtagRe = this.options.re
      doc.descendants((node, pos) => {
        if (node.isText && node.text) {
          for (const match of node.text.matchAll(hashtagRe)) {
            if (match.groups?.hashtag) {
              const hashtagIndex = (match?.index || 0) + match[0].indexOf(match.groups.hashtag)
              const hashtagLen = match.groups.hashtag.length
              result.push({
                from: pos + hashtagIndex,
                to: pos + hashtagIndex + hashtagLen,
              })
            }
          }
        }
      })
      return result
    }

    const hashtagDecorations = (doc) => {
      const decorations = []
      findHashtags(doc).forEach((hashtag) => {
        decorations.push(Decoration.inline(hashtag.from, hashtag.to, { class: this.options.decorationClass }))
      })
      return DecorationSet.create(doc, decorations)
    }

    const hashtagPlugin = new Plugin({
      key: new PluginKey('relation'),
      state: {
        init(_, { doc }) {
          return hashtagDecorations(doc)
        },
        apply(tr, old) {
          return tr.docChanged ? hashtagDecorations(tr.doc) : old
        },
      },
      props: {
        decorations(state) {
          return this.getState(state)
        },
      },
    })
    plugins.push(hashtagPlugin)

    if (this.options.relation) {
      plugins.push(
        Suggestion({
          pluginKey: new PluginKey('hash-relation'),
          editor: this.editor,
          char: this.options.char,
          startOfLine: this.options.startOfLine,
          allowSpaces: this.options.allowSpaces,
          command: ({ editor, range, props, ...rest }) => {
            editor
              .chain()
              .focus()
              .deleteRange(range)
              .command(({ tr }) => {
                // manipulate the transaction
                if (!props.id) {
                  return
                }
                tr.insertText(props.id + ' ')
                return true
              })
              .run()
          },
          ...this.options.relation,
        }),
      )
    }

    return plugins
  },
})
